import React, { useEffect, useRef, useState, useContext } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useHistory, useLocation } from 'react-router-dom';
import { requestCanceller } from '../../service/axiosCancelToken';
import { getProductsArchive } from '../../service/productService';
import MainContext from '../context/mainContext';
import LoadingBar from '../shared/LoadingBar';
import LoadingSpinner from '../shared/LoadingSpinner';
import shopImage from './../container/image/shop.png';
import Product from './product';
import './products.css';
import Cookies from 'universal-cookie';
let cookie = new Cookies();

const Products = () => {

    const history = useHistory();
    const { state } = useLocation();
    
    const [products, setProducts] = useState();
    const [isLoading, setIsLoading] = useState(false);

    const [searchInput, setSearchInput] = useState('');
    const [lastItemId, setLastItemId] = useState('');
    const [hasMore, setHasMore] = useState(true);
    const context = useContext(MainContext)

    const [category] = useState(() => {
        if(state && state.category)
        return state.category;
        else
        return {_id: 'all', title: '*** همه ***'}
    })

    const productsRef = useRef(null);
    const productsCountRef = useRef(null);

    const onSearchHandler = (event) => {
        productsRef.current = null;
        productsCountRef.current = null;
        let searched = event.target.value;
        setSearchInput(searched);
        setLastItemId('');
        setHasMore(true);
        setIsLoading(true);
    };

    useEffect(() => {
        if (products && productsCountRef && productsCountRef.current <= products.length) {
            setHasMore(false);
        }
    }, [products, productsCountRef]);

    const fetchMoreData = async () => {
        const lastItemId = products[products.length - 1]._id;
        setLastItemId(lastItemId);
    };

    useEffect(() => {
        const cancelRequest = requestCanceller();

        const fetchAllProducts = async () => {
            try {
                let params = { 
                    id: lastItemId, 
                    searchText: searchInput,
                    categoryId: category._id,
                }
                let { status, data } = await getProductsArchive(params, { cancelToken: cancelRequest.signal });
                if (status === 201) {
                    productsCountRef.current = data.counts;
                    if (productsRef.current) {
                    productsRef.current = productsRef.current.concat(data.products);
                    setProducts(productsRef.current);

                    }
                    else {
                        productsRef.current = data.products;
                        setProducts(productsRef.current);
                    }
                    setIsLoading(false);
                }
            } catch (err) {

            }
        }
        fetchAllProducts();
        return () => {
            cancelRequest.cancel();
        }
    }, [searchInput, lastItemId, category]);

 
    const setShoppingCartHandler = (itemId, action, minValue) => {
        let items = cookie.get('shoppingCart') ? cookie.get('shoppingCart') : [];
        let findedIndex = items.findIndex(item => item._id === itemId);

        if(findedIndex > -1){
            switch (action) {
                case 'INCREMENT':
                    items[findedIndex].count += 1; 
                    context.setShoppingCart([...items])
                    cookie.set('shoppingCart', [...items])
                    break;
                case 'DECREMENT':
                    items[findedIndex].count -= 1; 
                    if(items[findedIndex].count < minValue){
                        items.splice(findedIndex, 1);
                    }
                    context.setShoppingCart([...items])
                    cookie.set('shoppingCart', [...items])
                    break;
                default:
                    break;
            }
        }
        else if(action === 'INCREMENT') {
            items.push({_id: itemId, count: minValue});
            context.setShoppingCart([...items]);
            cookie.set('shoppingCart', [...items])
        }
    }

    return ( 
        <div className="products-layer-archive">
            <div className="container">
                <header className="">
                    <div className="">
                        <img src={shopImage} alt="" className="main-image-top mr-1"/>
                        <small className="font-weight-bold ki-link"
                            onClick={() => history.replace('/shop')}
                        >
                         فروشگاه ( مواد غذایی، سبزیجات، میوه و ...) / 
                        </small>
                        <small className="font-weight-bold">{category.title}</small>
                    </div>
                    <div className="d-flex justify-content-center  align-items-center mt-2">
                        <div>
                            <div className="d-flex mx-md-0 search-ki-category mt-2 ">
                                <span className="">
                                    <i className="fa fa-search"></i>
                                </span>
                                <input
                                    type="text"
                                    productholder="جستجو کنید"
                                    className="col inline-block form-control"
                                    onChange={onSearchHandler}
                                    value={searchInput}
                                />
                            </div>
                        </div>
                    </div>
                </header>  
                <section>
                    {
                        (isLoading || !products) ?
                        <div style={{ height: '60vh' }} className="d-flex">
                            <div className="text-center align-self-center mx-auto">
                                <LoadingSpinner />
                            </div>
                        </div>
                        :
                        <InfiniteScroll
                            dataLength={products && products.length}
                            next={fetchMoreData}
                            hasMore={hasMore}
                            loader={
                                <div className="d-flex mt-2">
                                    <span className="mx-auto">
                                        <LoadingBar
                                            type="spinningBubbles"
                                            color="#0eac1b"
                                        />
                                    </span>
                                </div>
                            }
                            endMessage={
                                <p className="text-center mt-3">
                                </p>
                            }
                        >
                            <div className="products-list-layer">
                                {
                                    products.map((product, index) => 
                                        <Product
                                            id={product._id}
                                            key={product._id}
                                            productId={product._id}
                                            title={product.title}
                                            unit={product.unit}
                                            ourPrice={product.ourPrice}
                                            generalPrice={product.generalPrice}
                                            score={product.score}
                                            minValue={product.minValue}
                                            info={product.info}
                                            number={index + 1}
                                            setShoppingCart={(itemId, action, minValue) => setShoppingCartHandler(itemId, action, minValue)}
                                            shopSelectedItems={cookie.get('shoppingCart') || []}
                                        />  
                                    ) 
                                }
                            </div>
                        </InfiniteScroll>
                    }
                </section>  
            </div>
        </div>
     );
}
 
export default Products;